export const tabsSectionConfig = {
    name: 'TabsSection',
    category: 'Zapier Sections',
    image: 'https://cdn.zappy.app/4f358d25a3f6a8c4560b262b80b3dd63.png',
    includeScrollTracking: true,
    inputs: [
        {
            name: 'heading',
            type: 'string',
            defaultValue: 'Section Heading',
        },
        {
            name: 'subheading',
            type: 'string',
            defaultValue: 'Section Subheading',
        },
        {
            name: 'tabs',
            type: 'list',
            /**
             * @see Input.broadcast
             * Without / With: https://cdn.zappy.app/4f79ffebd8463d62e5aa82152fd5c8b5.png
             */
            broadcast: true,
            subFields: [
                {
                    name: 'heading',
                    type: 'string',
                    defaultValue: 'Tab Heading',
                },
                {
                    name: 'id',
                    type: 'string',
                },
                {
                    name: 'content',
                    type: 'uiBlocks',
                    hideFromUI: true,
                    defaultValue: [],
                },
            ],
            defaultValue: [
                {
                    heading: 'Tab Heading 01',
                    content: [],
                },
                {
                    heading: 'Tab Heading 02',
                    content: [],
                },
            ],
        },
        {
            name: 'changeUrlOnTabChange',
            type: 'boolean',
        },
    ],
};
//# sourceMappingURL=config.js.map